<style lang="less">
	tr td:first-child{
		font-weight: bold;
		width: 25%;
	}
	.text-large{
		font-size: 1.2em;
	}
</style>
<template>


	<div class="pa-3" v-if="appointment">
		<span class="title">{{project.participantName ? project.participantName : project.clientName }}</span><br/>
		<span class="subtitle-2">{{ localAppointmentTimeString }}</span>
				<p class="text-large mt-4">This video meeting is being recorded</p>
		<div v-if="appointment.videoMeeting">
			<span v-if="appointment.videoMeeting" class="subtitle-1">Interviewer: {{appointment.videoMeeting.moderatorName}}</span>
			<div v-if="appointment.videoMeeting.moderatorInstructions">{{appointment.videoMeeting.moderatorInstructions}}</div>
			<div v-if="live">
				<v-btn v-if="!shareScreen" color="green" dark class="mt-4 mr-2" @click="$emit('startScreenShare')">Share screen</v-btn>
				<v-btn v-else color="red" dark class="mt-4 mr-2" @click="$emit('endShareScreen')">Stop Screen Sharing</v-btn>
			</div>
			<v-divider
			class="mt-3 mb-3"
			></v-divider>
			<div v-if="live">
				<VideoChat :user="user" :appointment="appointment" :participant="participant"></VideoChat>
			</div>
			
		</div>
		<div v-else>
			<p class="mb-5">Awaiting researcher</p>
		</div>

		<v-btn v-if="live" color="red" dark x-large width="100%" class="mt-4" @click="$emit('endVideo')">End Video</v-btn>

	</div>
</template>

<script>
	import Vuex from "vuex";
	import {prettyPrint} from "../../../assets/utilities.js";
	import {localDateTimeString} from "../../../assets/timezoneFunctions.js"
	export default{
		name: 'ParticipantSidePanel',
		props: ["appointment", "project", "live", "shareScreen", "user", "participant"],
		components: {
			VideoChat: () => import('../video/VideoChat')
		},
		computed: {
			...Vuex.mapState({
				userDetails: state => state[state.auth.view].user
			}),
			localAppointmentTimeString(){
				if( !this.appointment.dateTime ){ return ""; }
				return localDateTimeString(this.userDetails, this.appointment.dateTime.toDate(), "LONG" )
			},
		},
		methods:{
			prettyPrint: prettyPrint
		}
	}
</script>